const pageNameKey = "login";

export const loginEn = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Unfortunately, the user may be not logged in and/or additional interaction is required.",
    signingOutMessage: "Signing you out...",
    redirectingToLoginPage: "Redirecting to the login page",
  },
};

export const loginPtBr = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Infelizmente, o usuário pode não estar autenticado e/ou pode ser necessária interação adicional.",
    signingOutMessage: "Saindo...",
    redirectingToLoginPage: "Redirecionando para a página de login",
  },
};

export const loginDe = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Leider ist der Benutzer möglicherweise nicht angemeldet und/oder zusätzliche Interaktion erforderlich.",
    signingOutMessage: "Sie werden abgemeldet...",
    redirectingToLoginPage: "Weiterleitung zur Anmeldeseite",
  },
};

export const loginZhHans = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "不幸的是，用户可能未登录，或者需要其他交互。",
    signingOutMessage: "正在注销...",
    redirectingToLoginPage: "正在重定向到登录页面",
  },
};

export const loginIt = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Purtroppo, l'utente potrebbe non aver effettuato l'accesso e/o potrebbe essere necessaria un'ulteriore interazione.",
    signingOutMessage: "Disconnessione in corso...",
    redirectingToLoginPage: "Reindirizzamento alla pagina di accesso",
  },
};

export const loginEs = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Desafortunadamente, es posible que el usuario no haya iniciado sesión y/o que se requiera una interacción adicional.",
    signingOutMessage: "Cerrando sesión...",
    redirectingToLoginPage: "Redirigiendo a la página de inicio de sesión",
  },
};

export const loginNl = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Helaas is de gebruiker mogelijk niet aangemeld en/of is aanvullende interactie vereist.",
    redirectingToLoginPage: "Doorverwijzen naar de aanmeldpagina",
    signingOutMessage: "U wordt afgemeld...",
  },
};

export const loginTr = {
  [pageNameKey]: {
    loginRequiredTextZitadelMessage:
      "Maalesef kullanıcı oturum açmamış olabilir ve/veya ek etkileşim gerekli olabilir.",
    redirectingToLoginPage: "Giriş sayfasına yönlendiriliyorsunuz",
    signingOutMessage: "Oturumunuz kapatılıyor...",
  },
};
